import {
  DISPOSITIVOPACIENTE_ERROR,
  DISPOSITIVOPACIENTE_LOADING,
  DISPOSITIVOPACIENTE_RESET,
  DISPOSITIVOPACIENTE_SUCCESS,
  DISPOSITIVOPACIENTEDELETE_LOADING,
  DISPOSITIVOPACIENTEDELETE_SUCCESS,
  DISPOSITIVOPACIENTEDELETE_ERROR,
  DISPOSITIVOPACIENTEAGREGAR_LOADING,
  DISPOSITIVOPACIENTEAGREGAR_SUCCESS,
  DISPOSITIVOPACIENTEAGREGAR_ERROR,
  DISPOSITIVOPACIENTE_FLGVINCULADO,
  DISPOSITIVOPACIENTEDELETE_RESET,
  DISPOSITIVOPACIENTEAGREGAR_RESET,
  RESET_PORTAL_CONTEXT
} from "../ActionTypes";

import dispositivoPacienteInitialState from "../initialStates/dispositivoPacienteInitialState";

const dispositivoPaciente = (state, { payload, type }) => {
  switch (type) {
    case DISPOSITIVOPACIENTE_LOADING:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: false,
          loading: true,
        },
      };
    case DISPOSITIVOPACIENTE_SUCCESS:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case DISPOSITIVOPACIENTE_ERROR:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: payload,
          loading: false,
        },
      };

    case DISPOSITIVOPACIENTEDELETE_LOADING:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: false,
          loading: true,
        },
      };
    case DISPOSITIVOPACIENTEDELETE_SUCCESS:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          loading: false,
          error: false,
          delete: payload,
        },
      };
      case DISPOSITIVOPACIENTEDELETE_ERROR:
        return {
          ...state,
          dispositivoPaciente: {
            ...state.dispositivoPaciente,
            error: payload,
            loading: false,
          },
        };
        case DISPOSITIVOPACIENTEDELETE_RESET:
          return {
            ...state,
            dispositivoPaciente: {
              ...state.dispositivoPaciente,
              delete: false,
            },
          };

    case DISPOSITIVOPACIENTEAGREGAR_LOADING:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: false,
          loading: true,
        },
      };
    case DISPOSITIVOPACIENTEAGREGAR_SUCCESS:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          loading: false,
          error: false,
          post: payload,
        },
      };
    case DISPOSITIVOPACIENTEAGREGAR_RESET:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          post: false,
        },
      };
    case DISPOSITIVOPACIENTEAGREGAR_ERROR:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: payload,
          loading: false,
        },
      };

    case DISPOSITIVOPACIENTE_FLGVINCULADO:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          flgVinculado: true,
         
        },
      };

    case DISPOSITIVOPACIENTE_RESET:
      return dispositivoPacienteInitialState;
      
    case RESET_PORTAL_CONTEXT:
      return dispositivoPacienteInitialState;

    default:
      return state;
  }
};

export default dispositivoPaciente;
